import React from "react";

const UITextarea = ({
    name,
    value,
    required,
    labelClassName,
    label,
    error,
    errorName,
    onChange,
    disabled,
    placeholder,
    color,
    props,
}) => {
    return (
        <div className="ui-input-component ui-textarea">
            {label && (
                <label htmlFor={name} className={labelClassName}>{label}</label>
            )}
            {error && errorName && (
                <label className="input-error">{errorName}</label>
            )}
            {error && typeof error !== 'boolean' && (
                <label className="input-error">{error}</label>
            )}
            <div className={`ui-textarea-container ${error ? 'input-error': ''}`}>
                <textarea
                    {...props}
                    name={name}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    required={required}
                    placeholder={placeholder}
                    disabled={disabled}
                    style={{
                        color: color ? `#${color}` : ''
                    }}
                ></textarea>
            </div>
        </div>
    );
}

export default UITextarea;
